export default __webpack_public_path__ + "static/media/youtube.a166d430.svg";